/** Matches `basePath` in next.config.mjs (via NEXT_PUBLIC_BASE_PATH). */
export const basePath = process.env.NEXT_PUBLIC_BASE_PATH ?? ''

/** Public folder asset URL, prefixed when the app is hosted under a subpath. */
export function assetPath(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`
  return `${basePath}${normalized}`
}
